import "@/index.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { AnimatePresence } from "framer-motion";
import { Toaster } from "sonner";
import { ThemeProvider, useTheme } from "@/contexts/ThemeContext";
import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import ForgotPassword from "@/pages/ForgotPassword";
import ResetPassword from "@/pages/ResetPassword";
import Dashboard from "@/pages/Dashboard";
import Generate from "@/pages/Generate";
import Library from "@/pages/Library";
import Calendar from "@/pages/Calendar";
import Boost from "@/pages/Boost";
import Video from "@/pages/Video";
import Stats from "@/pages/Stats";
import Pricing from "@/pages/Pricing";
import Profile from "@/pages/Profile";
import SEOGenerator from "@/pages/SEOGenerator";
import SEOPages from "@/pages/SEOPages";
import Ranking from "@/pages/Ranking";
import CGU from "@/pages/CGU";
import Privacy from "@/pages/Privacy";
import Cookies from "@/pages/Cookies";
import AuthCallback from "@/components/AuthCallback";
import ProtectedRoute from "@/components/ProtectedRoute";
import AssistantBot from "@/components/AssistantBot";
import CookieBanner from "@/components/CookieBanner";
import AnimatedBackground from "@/components/AnimatedBackground";

function AppRouter() {
  const location = useLocation();
  
  if (location.hash?.includes('session_id=')) {
    return <AuthCallback />;
  }
  
  return (
    <AnimatePresence mode="wait">
      <Routes location={location} key={location.pathname}>
        <Route path="/" element={<Landing />} />
        <Route path="/login" element={<Login />} />
        <Route path="/register" element={<Register />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/reset-password" element={<ResetPassword />} />
        <Route path="/pricing" element={<Pricing />} />
        <Route path="/cgu" element={<CGU />} />
        <Route path="/privacy" element={<Privacy />} />
        <Route path="/cookies" element={<Cookies />} />
        
        <Route path="/dashboard" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
        <Route path="/generate" element={<ProtectedRoute><Generate /></ProtectedRoute>} />
        <Route path="/seo-generator" element={<ProtectedRoute><SEOGenerator /></ProtectedRoute>} />
        <Route path="/seo-pages" element={<ProtectedRoute><SEOPages /></ProtectedRoute>} />
        <Route path="/ranking" element={<ProtectedRoute><Ranking /></ProtectedRoute>} />
        <Route path="/library" element={<ProtectedRoute><Library /></ProtectedRoute>} />
        <Route path="/calendar" element={<ProtectedRoute><Calendar /></ProtectedRoute>} />
        <Route path="/boost" element={<ProtectedRoute><Boost /></ProtectedRoute>} />
        <Route path="/video" element={<ProtectedRoute><Video /></ProtectedRoute>} />
        <Route path="/stats" element={<ProtectedRoute><Stats /></ProtectedRoute>} />
        <Route path="/profile" element={<ProtectedRoute><Profile /></ProtectedRoute>} />
      </Routes>
    </AnimatePresence>
  );
}

function ThemedToaster() {
  const { isDark } = useTheme();
  return <Toaster position="top-right" theme={isDark ? "dark" : "light"} richColors />;
}

function App() {
  return (
    <ThemeProvider>
      <div className="App relative min-h-screen">
        <AnimatedBackground />
        <BrowserRouter>
          <AppRouter />
          <AssistantBot />
          <CookieBanner />
          <ThemedToaster />
        </BrowserRouter>
      </div>
    </ThemeProvider>
  );
}

export default App;
